import { isObject } from 'lodash';
import validation from '../../../scripts/services/validation';
import { formatPhone, getLkLink } from '../../../scripts/utils';
import { trackCalltrackingClick } from './tracking';
import { isDealRent } from '../../../scripts/services/rent-deal.service';
import { isPhonesUnique, getPhoneIndex } from './utils';
import { getPhone } from '../../../../../shared/utils';
import { loadPublishTerms, setCalltrackingEnabled } from '../../../../../shared/redux/reducers';

export const ContactInfoCtrl = [
  '$rootScope', '$scope', 'userService', 'analyticsService', 'placingTermsApi', '$sce', 'deviceService', 'popupService',
  'store', 'publishTermsService',
  function (
    $rootScope, $scope, userService, analyticsService, placingTermsApi, $sce, deviceService, popupService, store,
    publishTermsService,
  ) {
    this.images = {
      calltrackingHeadphones: require('../../../resources/assets/images/calltracking/calltracking-headphones.png'),
      calltrackingPolice: require('../../../resources/assets/images/calltracking/calltracking-police.png'),
      calltrackingThinking: require('../../../resources/assets/images/calltracking/calltracking-thinking.png'),
      calltrackingHomeowner: require('../../../resources/assets/images/calltracking/calltracking-homeowner.png'),
    };

    this.isMobile = deviceService.isMobile;

    if (!Array.isArray(this.phones)) {
      this.phones = [];
    }

    this.validationPhone0 = validation(this.form, 'phones.0', {
      required: 'Укажите номер телефона',
    });

    this.validationPhone1 = validation(this.form, 'phones.1', {
      required: 'Укажите номер телефона',
      unique: 'Вы уже ввели этот номер телефона. Укажите другой номер.'
    });

    const isPhoneAvailable = () => {
      const { offer: { phones } } = store.getState();

      if (!Array.isArray(phones)) {
        return false;
      }

      return phones.some(isObject);
    };

    this.isFirstPhoneRequired = () => !isPhoneAvailable(); // поле обязательно если ни один из телефонов не заполнен

    if (publishTermsService.isNewPublishTermsEnabled()) {
      $scope.$watch(() => store.getState().offer.phones, (phones) => {
        const { offer: { calltrackingPhoneIndex } } = store.getState();

        if (this.isFirstPhoneRequired() && this.isCalltrackingSelected()) {
          store.dispatch(setCalltrackingEnabled(false));
        }

        if (!Array.isArray(phones)) {
          return;
        }

        if (Number(calltrackingPhoneIndex) + 1 > phones.length) {
          this.ad.calltrackingPhoneIndex = 0;
        }
      }, true);

      $scope.$watch(() => store.getState().offer.calltrackingPhoneIndex, (calltrackingPhoneIndex) => {
        const { offer: { phones } } = store.getState();

        if (!Array.isArray(phones)) {
          return;
        }

        this.ad.calltrackingPhone = getPhone(phones[calltrackingPhoneIndex]);

        store.dispatch(loadPublishTerms());
      }, true);
    } else {
      $scope.$watch(() => this.ad.phones, () => {
        if (this.isFirstPhoneRequired() && this.isCalltrackingSelected()) {
          placingTermsApi.removeAdditionalById('calltracking');
        }

        if (Number(this.ad.calltrackingPhoneIndex) + 1 > this.ad.phones.length) {
          this.ad.calltrackingPhoneIndex = 0;
        }
      }, true);

      $scope.$watch(() => this.ad.calltrackingPhoneIndex, () => {
        this.ad.calltrackingPhone = getPhone(this.ad.phones[this.ad.calltrackingPhoneIndex]);

        $rootScope.$emit('terms.changed');
      }, true);
    }

    // replacedPhone устанавливается в ФВУ
    this.replacedPhoneIndex = () => getPhoneIndex(this.ad.phones, this.ad.replacedPhone);

    this.ad.calltrackingPhoneIndex = 0;

    this.shouldDisplayCalltracking = () =>
      placingTermsApi.isCalltrackingAvailable &&
      isPhoneAvailable() &&
      !isDealRent();

    this.handleCalltrackingTermClick = (e) => {
      const calltrackingOption = this.calltrackingOption();
      const checkbox = e.target;
      const isChecked = checkbox.checked;

      store.dispatch(setCalltrackingEnabled(isChecked));

      if (isChecked) {
        placingTermsApi.selectOption(calltrackingOption);
      } else {
        placingTermsApi.removeAdditionalById('calltracking');
      }

      trackCalltrackingClick(isChecked, calltrackingOption.selectedPeriod.marketingPrice);
    };

    this.calltrackingOption = () => {
      if (publishTermsService.isNewPublishTermsEnabled()) {
        const { calltracking } = store.getState();

        return calltracking;
      } else {
        return placingTermsApi.calltrackingOption;
      }
    };

    this.isCalltrackingSelected = () => {
      if (publishTermsService.isNewPublishTermsEnabled()) {
        const { calltracking: { isEnabled } } = store.getState();

        return isEnabled;
      } else {
        return placingTermsApi.isCalltrackingSelected();
      }
    }

    /**
     * Возвращает флаг обязательности услуги коллтрекинга в данном регионе
     */
    this.isCalltrackingCompulsory = () => {
      if (publishTermsService.isNewPublishTermsEnabled()) {
        const { calltracking: { isCompulsory } } = store.getState();

        return isCompulsory;
      } else {
        return placingTermsApi.calltrackingOption?.isCompulsory;
      }
    };

    this.isFirstPhoneCalltrackingIconVisible = () => {
      const calltrackingOption = this.calltrackingOption();

      if (!calltrackingOption || !this.isCalltrackingSelected()) {
        return false;
      }

      if (calltrackingOption.isCompulsory) {
        return calltrackingOption.calltrackingPhoneSubstitutionsCount >= 1;
      }

      // Добровольный КТ
      return false;
    };

    this.isSecondPhoneCalltrackingIconVisible = () => {
      const calltrackingOption = this.calltrackingOption();

      if (!calltrackingOption || !this.isCalltrackingSelected()) {
        return false;
      }

      if (calltrackingOption.isCompulsory) {
        return calltrackingOption.calltrackingPhoneSubstitutionsCount === 2;
      }

      // Добровольный КТ
      return false;
    };

    this.isSecondPhoneNumberAvailable = () => {
      const calltrackingOption = this.calltrackingOption();

      if (!calltrackingOption || !this.isCalltrackingSelected()) {
        return true;
      }

      if (calltrackingOption.isCompulsory) {
        return calltrackingOption.calltrackingPhoneSubstitutionsCount === 2;
      }

      // Добровольный КТ
      return true;
    };

    if (window.chats.chatIsEnabled) {
      this.messagingEmail = userService.user.email;
      this.showChatsBlock = !window.chats.userChatsIsEnabled;
    }

    this.formatPhone = formatPhone;

    this.enableChats = () => {
      userService.enableChats()
        .then(() => {
          this.showChatsBlock = false;
        });

      analyticsService.enableChats();
    };

    this.validateDuplicates = () => {
      if (this.form['phones.1']) {
        this.form['phones.1'].$setValidity('unique', isPhonesUnique(this.ad.phones[0], this.ad.phones[1]));
      }
    };

    this.getCalltrackingBlockTitle = () => {
      const {
        selectedPeriod
      } = this.calltrackingOption();
      const isAgent = this.isAgent();
      const isHomeowner = this.isHomeowner();

      if (isAgent) {
        if (selectedPeriod.marketingPrice === 0) {
          return 'Включить Call-tracking';
        }

        if (selectedPeriod.marketingPrice >= 0) {
          return $sce.trustAsHtml(
            `Включить Call-tracking за&nbsp;${selectedPeriod.marketingPrice}&nbsp;₽ на&nbsp;${selectedPeriod.label} <sup>*</sup>`
          );
        }
      }

      if (isHomeowner) {
        if (selectedPeriod.marketingPrice === 0) {
          return 'Защитить номер от&nbsp;спама бесплатно';
        }

        if (selectedPeriod.marketingPrice >= 0) {
          return $sce.trustAsHtml(
            `Защитить номер от спама за&nbsp;${selectedPeriod.marketingPrice}&nbsp;₽ на&nbsp;${selectedPeriod.label} <sup>*</sup>`
          );
        }
      }

      return 'Включить Call-tracking';
    };

    this.openCalltrackingPhoneHint = () => {
      if (!this.isMobile) {
        return;
      }

      popupService.openPopup('hint', {
        text: 'В объявлении будет показан временный номер',
        title: 'Включён Call-tracking',
        hideCloseButton: true,
      });
    };

    this.getLkLink = getLkLink('');

    this.isHomeowner = () => this.ad.isByHomeowner;
    this.isAgent = () => !this.ad.isByHomeowner;
  }
];
